var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "#BABCC1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9949 5.77825C18.9973 5.7173 18.9997 5.65682 18.9997 5.59541C18.9997 3.13361 16.8898 1.00094 14.2868 1.00094C12.3838 1.00094 10.7452 2.20628 10.001 3.74215C9.25575 2.20534 7.61716 1 5.71412 1C3.11114 1 1.00036 3.13361 1.00036 5.59447C1.00036 5.65588 1.00274 5.71636 1.00512 5.77731C1.00512 5.77731 0.738776 8.70136 4.04646 11.894C5.55069 13.3769 7.23217 14.7867 10 17C12.7683 14.7867 14.4498 13.3774 15.9559 11.895C19.2608 8.7023 18.9949 5.77825 18.9949 5.77825Z",
    stroke: "#BABCC1",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteGrey);
export default __webpack_public_path__ + "static/media/favorite-grey.401d910d835e39426f4b74e8607a8d86.svg";
export { ForwardRef as ReactComponent };